<mat-form-field>
  <input
    matInput
    [formControl]="control"
    [placeholder]="placeholder"
    [type]="type"
    [ngClass]="customClass"
    [disabled]="disabled" />
</mat-form-field>
